// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"00aeb481","493":"c1243a7c","694":"8918ede0","803":"47989c2f"}[chunkId] + ".chunk.css";
};